import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"];
import UISelect from 'UIComponents/input/UISelect';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectItemWithTooltip = _ref => {
  let {
      children,
      option
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(UITooltip, {
      use: option.use || 'danger',
      placement: option.placement || 'top',
      Content: option.tooltipContent,
      disabled: !option.disabled,
      children: children
    })
  }));
};
const TooltipSelect = props => /*#__PURE__*/_jsx(UISelect, Object.assign({
  itemComponent: SelectItemWithTooltip
}, props));
export default TooltipSelect;